<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">{{ assignModalTitle }}</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="form-group row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;" v-if="(hasLicense > 0 || unlimited == true)">
              <b>Are you sure you want to assign {{ unitType }} to {{ menteeName }}?</b>
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;" v-else>
              <b>Do you want to add a {{ unitType }}?</b>
              <div style="padding-top: 2px">
                To activate a user, please purchase a {{ unitType }}.
              </div>
            </div>
        </div>
        <div class="col-12 p-0" style="margin-top: 30px;">
          <div class="col-6 p-0 float-left" style="text-align: left;">
            <button type="submit" class="btn btn-sm closeBtn" @click="closeModal">Cancel</button>
          </div>
          <div class="col-6 p-0 float-left" style="text-align: right;" v-if="(hasLicense > 0  || unlimited == true)">
            <button :disabled="disable_license_button" type="submit" class="btn btn-md ma-blue-btn" @click="onSubmit">Assign {{ unitType }}</button>
          </div>
          <div class="col-6 p-0 float-left" style="text-align: right;" v-else-if="type != ''">
            <button type="submit" class="btn btn-md ma-blue-btn" @click="showAddLicenseForm">Add {{ unitType }}</button>
          </div>
        </div>
      </div>
     </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';

export default {
  props: [
    'isModalVisible',
    'license_expire_date',
    'license_account_id',
    'hasLicense',
    'assignModalTitle',
    'menteeName',
    'menteeId',
    'unitType',
    'type',
    'unlimited',
    ],
  data() {
    return {
      loading: false,
      expire_date: '',
      reassign_license_count: 0,
      reassign_license_option_selected: '',
      disable_license_button: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    getReassignLicenseOptionsSelected(reassignLicenseOptions) {
      if(reassignLicenseOptions) {
        this.reassign_license_option_selected = reassignLicenseOptions[0].id;
      }

    },
    onSubmit() {
      this.disable_license_button = true;
        axios('/desktop/create-mentee-license',
        {
          method: 'POST',
          data: {
            mentee_id: this.menteeId,
            account_id: this.$store.state.user_accountid,
            license_account_id: this.license_account_id,
          },
        })
        .then(() => {
          this.disable_license_button = false;
          this.$parent.getMenteeLicense();
          this.$emit('close');
        })
        .catch((error) => {
          this.disable_license_button = false;
        });

    },
    showAddLicenseForm() {
      this.$parent.isAssignModalVisible = false;
      this.$parent.isAddLicenseModalVisible = true;
      this.$parent.$refs.AddLicenseModal.loadInitialData();
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
 }
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  width: 150px;
}
.ma-white-btn {
  width: 150px;
}
.ma-white-btn {
  width: 110px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.reassign_options {
  margin-top: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/assign_license_modal.vue